// ─────────────────────────────────────────────────────────────
//  Segment Report — types & API transform.
//  rows = customer segments (values are display-ready strings)
// ─────────────────────────────────────────────────────────────
const toNumber = (v) => {
    if (v == null)
        return 0;
    const n = typeof v === "number" ? v : Number(String(v).replace(/[$,%\s]/g, ""));
    return Number.isNaN(n) ? 0 : n;
};
const formatCount = (v) => toNumber(v).toLocaleString("en-US");
// Derive the human label from the order count (1 → "One-time buyers", n → "n-time buyers").
const segmentLabel = (orders) => orders === 1 ? "One-time buyers" : `${orders}-time buyers`;
/**
 * Transform the API's `customer_segment_report` array into rows the
 * <SegmentReport /> table renders. Values already formatted by the API
 * (currency, percentages) are passed through as-is; counts and lifespan
 * get light client-side formatting to match the existing display style.
 */
export const buildSegmentRows = (report) => {
    if (!Array.isArray(report))
        return [];
    return report.map((r, idx) => {
        const orders = toNumber(r.orders);
        return {
            id: `seg-${orders || idx}`,
            segment: segmentLabel(orders),
            orderSegment: orders,
            orders: orders.toLocaleString("en-US"),
            customers: formatCount(r.total_customers),
            percentOfTotal: r.p_of_total != null ? String(r.p_of_total) : "—",
            aov: r.aov != null ? String(r.aov) : "—",
            orderValue: r.order_value != null ? String(r.order_value) : "—",
            averageLifespan: `${toNumber(r.average_customer_lifespan).toFixed(2)}`,
            customerValue: r.customer_value != null ? String(r.customer_value) : "—",
            purchaseCycle: toNumber(r.repeat_order_frequency)
                ? toNumber(r.repeat_order_frequency).toFixed(2)
                : '0.00',
        };
    });
};
